// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"News-module--buttonWrapper--g4P7x","button":"News-module--button--37K1o","items":"News-module--items--1wedn","newsTitle":"News-module--newsTitle--1I1PE"};